import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError} from 'rxjs';
import { Parameters } from '../models/parameters';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApplicantSelected } from '../models/applicantSelected';
import { Chrono } from '../models/chrono';
import { Staff } from '../models/staff';


@Injectable()
export class StaffDashboardService{

    httpOptions = {
        headers: new HttpHeaders({
            'content-Type':'application/json',
            'Access-Control-Allow-Origin':'*',
            'Accept':'application/json'
        })
    };
    
    baseAPIUrl:string = environment.baseAPIUrl;

    constructor(private http:HttpClient) {
        //this.httpOptions.headers.append("Authorization", localStorage.getItem("jwtoken"));
    }



    getStaffInfoHCV(params:Parameters):Observable<Staff> {
        return this.http.post<Staff>(this.baseAPIUrl + 'api/hcvapplicants/GetStaffInfo', params, this.httpOptions)
            .pipe(catchError(this.handleError<Staff>('getStaffInfoHCV', null)));
    }

    getStaffInfoCNV(params:Parameters):Observable<Staff> {
        return this.http.post<Staff>(this.baseAPIUrl + 'api/cnvapplicants/GetStaffInfo', params, this.httpOptions)
            .pipe(catchError(this.handleError<Staff>('getStaffInfoHCV', null)));
    }

    getSelectedApplicantsByWaitlistHCV(params:Parameters):Observable<ApplicantSelected[]> {
        return this.http.post<ApplicantSelected[]>(this.baseAPIUrl + 'api/hcvapplicants/GetSelectedApplicantsByWaitlist', params, this.httpOptions)
            .pipe(catchError(this.handleError<ApplicantSelected[]>('getSelectedApplicantsByWaitlistHCV', [])));
    }

    getSelectedApplicantsByWaitlistCNV(params:Parameters):Observable<ApplicantSelected[]> {
        return this.http.post<ApplicantSelected[]>(this.baseAPIUrl + 'api/cnvapplicants/GetSelectedApplicantsByWaitlist', params, this.httpOptions)
            .pipe(catchError(this.handleError<ApplicantSelected[]>('getSelectedApplicantsByWaitlistCNV', [])));
    }

    getCurrentApplicantsByWaitlistHCV(params:Parameters):Observable<ApplicantSelected[]> {
        return this.http.post<ApplicantSelected[]>(this.baseAPIUrl + 'api/hcvapplicants/GetCurrentApplicantsByWaitlist', params, this.httpOptions)
            .pipe(catchError(this.handleError<ApplicantSelected[]>('getCurrentApplicantsByWaitlistHCV', [])));
    }

    getCurrentApplicantsByWaitlistCNV(params:Parameters):Observable<ApplicantSelected[]> {
        return this.http.post<ApplicantSelected[]>(this.baseAPIUrl + 'api/cnvapplicants/GetCurrentApplicantsByWaitlist', params, this.httpOptions)
            .pipe(catchError(this.handleError<ApplicantSelected[]>('getCurrentApplicantsByWaitlistCNV', [])));
    }

    getApplicantChronosHCV(params:Parameters):Observable<Chrono[]> {
        return this.http.post<Chrono[]>(this.baseAPIUrl + 'api/hcvapplicants/GetApplicantChronos', params, this.httpOptions)
            .pipe(catchError(this.handleError<Chrono[]>('getApplicantChronosHCV', [])));
    }

    getApplicantChronosCNV(params:Parameters):Observable<Chrono[]> {
        return this.http.post<Chrono[]>(this.baseAPIUrl + 'api/cnvapplicants/GetApplicantChronos', params, this.httpOptions)
            .pipe(catchError(this.handleError<Chrono[]>('getApplicantChronosCNV', [])));
    }
    



    private handleError<T> (operation = 'operation', result?:T){
        return (error:any): Observable<T> => {
            console.error(error);
            return of(result as T)
        }
    }

}